import React from 'react'
import { Button, Dropdown, Form } from 'semantic-ui-react'
import styled from 'styled-components'

import EasyToClickIcon from '../EasyToClickIcon'

/**
 * Single source-of-truth form for the customer-tag create / modify flow.
 *
 * Replaces the legacy pair `CustomerTagCreation` + `CustomerTagModificationDeletion`,
 * which had drifted: PET-1336's HTML5-Constraint-API → inline-validation fix landed
 * on the Create shell only, leaving the Modify shell on the legacy validation
 * pattern. Mode is selected per-call via the `mode` prop.
 *
 * @typedef {import('components/CustomerTagInput').CustomerTag} CustomerTag
 *
 * @param {object} props
 * @param {'create' | 'modify'} props.mode
 * @param {CustomerTag} [props.tag]                   Required when mode='modify'.
 * @param {() => void} props.onClickBack
 * @param {(tagName: string) => void} props.onSubmit  Replaces onCreateTag / onModifyTag.
 * @param {() => void} [props.onDelete]               Present only when mode='modify'.
 */
export default function CustomerTagForm({ mode, tag, onClickBack, onSubmit, onDelete }) {
  const isModify = mode === 'modify'

  function handleSubmit(e) {
    const tagName = e.target.customerTagName.value.trim()
    onSubmit(tagName)
  }

  function validateTag(e) {
    if (e.target.validity.patternMismatch) {
      e.target.setCustomValidity('Tag can not contain comma.')
    } else {
      e.target.setCustomValidity('')
    }
  }

  return (
    <React.Fragment>
      <Header>
        <EasyToClickIcon className="link grey icon fas fa-chevron-left " onClick={onClickBack} />
        <label className="ml-auto mr-auto bold">{isModify ? 'Change tag' : 'Create tag'}</label>
        <i className="link icon invisible" aria-hidden="true" />
      </Header>
      <Dropdown.Divider className="m0" />
      <Form onSubmit={handleSubmit}>
        <Form.Field>
          <label>Name</label>
          <input
            autoFocus
            defaultValue={isModify && tag ? tag.name : undefined}
            type="text"
            name="customerTagName"
            required
            pattern="[^,]+"
            onChange={validateTag}
            maxLength={50}
          />
        </Form.Field>
        <Button type="submit" primary size="small">
          Save
        </Button>
        {isModify && (
          <Button type="button" negative size="small" onClick={onDelete}>
            Delete
          </Button>
        )}
      </Form>
    </React.Fragment>
  )
}

const Header = styled.div`
  padding: 6px 10px;
  display: flex;
  align-items: center;
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomerTagForm/index.js